// extracted by mini-css-extract-plugin
export default {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","main":"xCSRK","oppositeGenderLinkWrapper":"Tzn0Q","brandValues":"FKCjW"};